'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _chart = require('helpers/chart');

var _ChartWrapper = require('components/ChartWrapper/ChartWrapper');

var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var PlayStatsColumnChart = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(PlayStatsColumnChart, _PureComponent);

  function PlayStatsColumnChart() {
    (0, _classCallCheck3.default)(this, PlayStatsColumnChart);
    return (0, _possibleConstructorReturn3.default)(this, (PlayStatsColumnChart.__proto__ || (0, _getPrototypeOf2.default)(PlayStatsColumnChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlayStatsColumnChart, [{
    key: 'getChartData',
    value: function getChartData() {
      var data = this.props.data;
      var t = this.context.t;

      var styleColumn = { type: 'string', role: 'style' };
      var columnStyle = 'stroke-width: 100;';

      return [[t('Date'), t('Plays'), styleColumn, t('Downloads'), styleColumn]].concat((0, _toConsumableArray3.default)((0, _chart.getDataArray)({
        data: data,
        keyName: 'date',
        valueName: function valueName(current) {
          return [current.plays, columnStyle, current.downloads, columnStyle];
        }
      })));
    }
  }, {
    key: 'getChartProps',
    value: function getChartProps() {
      var _props = this.props,
          id = _props.id,
          daysCount = _props.daysCount,
          chartOptions = _props.chartOptions;
      var t = this.context.t;

      var data = this.getChartData();

      return {
        graphId: id,
        chartType: 'ColumnChart',
        data: data,
        options: (0, _extends3.default)({
          bar: {
            groupWidth: daysCount === 1 ? 100 : undefined
          },
          chartArea: {
            width: 'auto',
            top: 10,
            left: 'auto'
          },
          hAxis: {
            title: t('Date'),
            format: _chart.chartDateFormat.monthStr,
            gridlines: {
              count: daysCount + 2,
              units: {
                milliseconds: { format: [_chart.chartDateFormat.monthStr] }
              }
            },
            minorGridlines: {
              count: 0,
              color: '#fff'
            },
            ticks: daysCount === 1 ? [data[1][0]] : undefined
          },
          vAxis: {
            title: t('Number of recipients'),
            format: '#',
            baseline: -0.05,
            minValue: 2,
            viewWindow: {
              min: -0.05
            }
          }
        }, chartOptions),
        dateFormat: {
          columns: [0],
          options: {
            pattern: _chart.chartDateFormat.date
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          height = _props2.height,
          loading = _props2.loading;

      var chartProps = this.getChartProps();

      return _react2.default.createElement(_ChartWrapper2.default, {
        height: height,
        showScale: true,
        scaleHeight: 50,
        chartProps: chartProps,
        loading: loading
      });
    }
  }]);
  return PlayStatsColumnChart;
}(_react.PureComponent), _class2.propTypes = {
  chartOptions: _propTypes2.default.object,
  data: _propTypes2.default.array,
  daysCount: _propTypes2.default.number,
  height: _propTypes2.default.number,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  chartOptions: {},
  data: [],
  height: 400,
  id: 'playStatsColumnChart'
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
exports.default = PlayStatsColumnChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/PlayStatsChart/PlayStatsColumnChart.js
// module id = 2114
// module chunks = 1